import React, { useEffect, useMemo } from 'react';
import CustomSelect from '../../components/CustomSelect';
import { sentimentOptions } from '../../constants/sentiment';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { topicSentimentPlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import { sentimentIconMap } from '@/pages/opinion/constants';
import { useIntl } from 'umi';
import BubbleCommon, { commonTopicSentimentTips } from '../../../BubbleCommon';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function SubTopicSentimentSelect({
  changeOnCloseWindow,
  onChange,
  defaultKey,
  defaultValue,
  filterValue,
  oriDefaultFilter,
  lang,
}: SingleCommonType) {
  const { formatMessage } = useIntl();
  const {
    selects: selectSentiment,
    setSelects: setSelectSentiment,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'sub_topic_sentiment',
    options: sentimentOptions(formatMessage).map((item) => item.value),
  });

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  function getCommonBackInfo() {
    const [text, isAll] = getButtonElement();
    return commonBackInfo(
      { sub_topic_sentiment: selectSentiment.map(Number) },
      { [defaultKey]: text },
      { needChangeEntity: true, isNumber: true, isAll },
    );
  }

  useEffect(() => {
    onChange?.('subTopicSentiment', getCommonBackInfo());
  }, [selectSentiment]);

  const sentimentValue = useMemo(() => {
    return selectSentiment.map(String);
  }, [selectSentiment]);

  return (
    <div className={`sub-topic-sentiment-select-wrapper ${diffClassName}`}>
      <BubbleCommon
        placement="left"
        showIcon={false}
        tipsMap={commonTopicSentimentTips}
      >
        <CustomSelect
          ref={customSelectRef}
          buttonItemRender={(value: any) => {
            return (
              <SvgIcon
                type={sentimentIconMap[value]}
                className="dbo-select-icon"
              />
            );
          }}
          buttonAllRender={[5, 1, 3].map((value) => (
            <SvgIcon
              key={value}
              type={sentimentIconMap[value]}
              className="dbo-select-icon"
            />
          ))}
          placeholderText={topicSentimentPlaceholder[lang]}
          onClear={() => setSelectSentiment([])}
          selectOptionsInfo={[sentimentValue, setSelectSentiment]}
          options={sentimentOptions(formatMessage)}
          pointKey={FilterButtonPoint.subTopicSentiment}
          onChange={() => {
            const data = getCommonBackInfo();

            changeOnCloseWindow?.(data.value);
          }}
        ></CustomSelect>
      </BubbleCommon>
    </div>
  );
}
